import { render, staticRenderFns } from "./BaseTabControlHeadersItem.vue?vue&type=template&id=6bc2711e&scoped=true&"
import script from "./BaseTabControlHeadersItem.vue?vue&type=script&lang=js&"
export * from "./BaseTabControlHeadersItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc2711e",
  null
  
)

export default component.exports